import React from "react";
import Cookies from "universal-cookie";
import BackDecoration from "../Utils/BackDecoration";
import FootBar from "../Utils/FootBar";
import NavBar from "../Utils/NavBar";
import { SpinnerCircular } from "spinners-react";
import { FaTimesCircle } from "react-icons/fa";
import { useState, useEffect } from "react";
import axios from "axios";
import banner from "../../assets/images/banner2.jpeg";
const cookie = new Cookies();
require("../../assets/stylesheets/Categories/Categories.css");

var loading = true;

function Category() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getApiResponse = async () => {
      await axios
        .get(
          "https://ferias-ingenio-backend.vercel.app/api/categories/getcategories"
        )
        .then((res) => {
          setData(res.data);
          loading = false;
        })
        .catch((err) => {
          if (err) console.log(err);
        });
    };

    getApiResponse();
  }, []);

  return (
    <div className="categoriesDiv">
      <div className="loading">
        {loading && <SpinnerCircular secondaryColor="#000" />}
      </div>
      {Object.values(data).map((cat) => {
        let img = require(`../../assets/images/categories/${cat.title}.png`);
        return (
          <a key={cat.id} href={`./categories/${cat.id}/${cat.name}`}>
            <div className="category">
              <img src={img} alt={`${cat.title}`} />
              <div className="information">
                <p>{cat.name}</p>
                <h5>Formada por {cat.matters.length} clases</h5>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}
const CategoriesSection = () => {
  return (
    <div className="categories">
      <h2>Categorías de la feria</h2>
      <Category />
    </div>
  );
};

const Banner = () => {
  const [visibility, setVisibility] = useState(true);

  useEffect(() => {}, [visibility]);

  const handleVisibility = () => {
    setVisibility(false);
  };

  return (
    <a onClick={handleVisibility} className={visibility ? "banner" : "hide"}>
      <span>
        <FaTimesCircle />{" "}
      </span>
      <div className="banner-img">
        <img src={banner} />
      </div>
    </a>
  );
};

function Categories() {
  return (
    <div className="inpages">
      <BackDecoration />
      <NavBar />
      <CategoriesSection />
    </div>
  );
}

export default Categories;